import { create } from 'zustand';

const useUserMode = create(set => ({
  userMode: 'line',
  setUserMode: userMode => set({ userMode }),
}));

export default useUserMode;